import React from 'react';
import Grid from '../Grid';
import {
  ManageStyled,
  Article,
  Figure,
  TextBlock,
  Title,
  Description,
  Link,
  BottomNote,
  DomainDiagram
} from './styled';

const Manage = () => {
  return (
    <ManageStyled>
      <Grid>
        <Article>
          <TextBlock>
            <Title>Centralized Feature Management and User Experience</Title>
            <Description>
              Thanks to Google and others, users are comfortable with redirecting to a trusted
              domain to authenticate. Implement your login page just once for all your apps and use
              the Auth0 dashboard to turn on and off features centrally for all your apps.
            </Description>
            <BottomNote>
              <h2>Features</h2>
              <p>
                For example, features such as social logins, MFA and Anomaly detection can be
                controlled directly from the dashboard for all your registered apps.
              </p>
            </BottomNote>
          </TextBlock>
          <Figure className="with-shadow">
            <img
              className="desktop-hidden"
              src="https://cdn.auth0.com/website/universal-login/mobile_centralized_feature_management.svg"
              alt="Centralized Feature Management"
            />
            <img
              className="mobile-hidden"
              src="https://cdn.auth0.com/website/universal-login/new-grid-02b.svg"
              alt="Centralized Feature Management"
            />
          </Figure>
        </Article>
        <Article>
          <TextBlock className="swap-order-2">
            <Title>Custom Domains</Title>
            <Description>
              Take a no-compromise approach to the login experience by using custom domains. With
              custom domains, you keep your users interacting with you within the context of your
              brand and users are not redirected to a third-party site that impacts the branding
              experience.
            </Description>
            <BottomNote>
              <img
                className="mobile-hidden url-bar"
                src="https://cdn.auth0.com/website/universal-login/univ-login-new-urlbar.svg"
                alt="Custom domain URL bar"
              />
              <p>
                For example, if your Auth0 domain is <b>acme.auth0.com</b>, you can have your users
                to see, use, and remain on <em>accounts.acme.com</em> which helps you preserve the
                brand context and the user experience during login.
              </p>
            </BottomNote>
          </TextBlock>
          <Figure className="swap-order-1 with-shadow">
            <img
              className="desktop-hidden"
              src="https://cdn.auth0.com/website/universal-login/universal-login-login-mobile.svg"
              alt="Customize your domains"
            />
            <img
              className="mobile-hidden"
              src="https://cdn.auth0.com/website/universal-login/universal-login-browser-login.svg"
              alt="Customize your domains"
            />
          </Figure>
        </Article>
        <Article>
          <TextBlock>
            <Title>Customize Login</Title>
            <Description>
              To customize the login page, you will have a couple of options to choose from. You can
              use Lock, a pre-built and easily configurable login widget to quickly enable a
              customized login interface.
            </Description>
            <BottomNote className="sdk mobile-hidden">
              <h2>
                <img
                  src="https://cdn.auth0.com/website/universal-login/node_js.svg"
                  alt="NodeJS logo"
                />
                AUTH0.JS SDK
              </h2>
              <p>
                Alternately, you can use our full featured Auth0.js SDK if you need to build your
                own custom login UI or implement more complex authentication functionality.
              </p>
            </BottomNote>
          </TextBlock>
          <Figure>
            <img
              src="https://cdn.auth0.com/website/universal-login/custom-logins-boxes.svg"
              alt="Customizable login box"
            />
          </Figure>
          <BottomNote className="sdk desktop-hidden">
            <h2>
              <img
                src="https://cdn.auth0.com/website/universal-login/node_js.svg"
                alt="NodeJS logo"
              />
              AUTH0.JS SDK
            </h2>
            <p>
              Alternately, you can use our full featured Auth0.js SDK if you need to build your own
              custom login UI or implement more complex authentication functionality.
            </p>
          </BottomNote>
        </Article>
      </Grid>
    </ManageStyled>
  );
};

export default Manage;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/Manage/Manage.js